// Backend API endpoint contract. Typed as a readonly string map instead of `any`
// so a typo in a call site is a compile error, not a silent 404.

export const apiEndpoints = {
  api: "/api",
  login: "/api/login",
  logout: "/api/logout",
  organizations: "/api/organizations",
  verify2FA: "/api/verify-2fa",
  resend2FA: "/api/resend-2fa",
  vehicles: "/api/vehicule",
  cancelTheSale: "/api/vehicule/cancelTheSale",
  cacheData: "/api/cache",
  soldVehicles: "/api/vehicule/sold",
  unsoldVehicles: "/api/vehicule/unsold",
  reservedVehicles: "/api/vehicule/reserved",
  files: "/api/vehicule/files",
  clientFiles: "/api/vehicule/clientFiles",
  clientVehicles: "/api/clientvehicles",
  multipleUpdate: "/api/vehicule/multipleUpdate/files",
  multipleDeletePhotos: "/api/vehicule/multipleDelete/files",
  changeBackground: "/api/vehicule/changeBackground",
  data_intrare_detailing: "api/interventii-detailing",
  data_intrare_vopsitorie: "api/interventii-vopsitorie",
  data_intrare_service: "api/interventii-service",
  reserveVehicle: "/api/vehicule/reserveVehicle",
  reserveForVehicle: "/api/vehicule/shipping/reserveForVehicle",
  deleteReserveForShipping: "/api/vehicule/shipping/deleteReserveForShipping",
  carOrders: "/api/carOrders",
  costs: "api/costuri-aditionale",
  guarantees: "api/costuri-aditionale",
  //ENDPOINT pentru update cache
  tip_vehicul_r: "api/tipuri-vehicule",
  status_id: "api/statusuri-vehicule",
  brand_r: "api/branduri-vehicule",
  model_r: "api/modele-vehicule",
  locatie_administrativa_r: "api/locatii-administrative",
  tip_achizitie_r: "api/tipuri-achizitie",
  firma_achizitie_r: "api/firme",
  furnizor_r: "api/furnizori",
  tip_caroserie_r: "api/tipuri-caroserii",
  culoare_r: "api/culori-vehicule",
  optiune_culoare_r: "api/optiuni-culori",
  tara_origine_r: "api/tari-origine",
  financingTypes: "api/tipuri-finantare",
  norma_poluare_r: "api/norme-poluare",
  combustibil_r: "api/tipuri-combustibil",
  tip_tractiune_r: "api/tipuri-tractiuni",
  cutie_viteze_r: "api/cutii-viteze",
  dotari_id: "api/dotari",
  tip_tva_r: "api/tva",
  tip_cost_adm_id: "api/tip-costuri-adm",
  users: "/api/users",
  roles: "api/roles",
  templates: "/api/templates",
  genericTemplates: "/api/genericTemplates",
  permissions: "api/permissions",
  tip_costuri: "api/tip-costuri",
  tip_costuri_adm: "api/tip-costuri-adm",
  clients: "/api/clients",
  clientsDocuments: "/api/clientsDocuments",
  userFilters: "/api/users/vehicles/filters",
  administrativeCosts: "/api/costuri-administrative",
  costsAdminType: "/api/tip-costuri-adm",
  logs: "/api/logs",
  negotiation_id: "/api/user/lista-notificari",
  permissions_id: "/api/permissions",
  settings: "/api/settings",
  unreadMessages: "/api/integration/clientMessages/unreadMessages",
  reports: "/api/reports",
  TVARecovered: "api/vehicule/tvaRecovered",
  user: "/api/users",
  bnrExchangeRates: "/api/bnrExchangeRates",
  numberOfVehicleForFinancialDepartment:
    "api/vehicule/numberOfVehicleForFinancialDepartment",
  notifications: "/api/notifications",
  markNotificationAsRead: "/api/notifications/markAsRead",
  markAllNotificationsAsRead: "/api/notifications/markAllAsRead",
  searchVehicles: "/api/vehicule/search",
  postOnSite: "/api/vehicule/postOnSite/",
  clientMessages: "/api/integration/clientMessages",
  shipping: "/api/shippings",
  transports: "/api/transports",
  drivers: "api/drivers",
  notes: "/api/notes",
  notesAll: "/api/notes/all",
  sendWhatsappTemplate: "/api/sendWhatsappTemplate",
  sendWhatsappText: "/api/sendWhatsappText",
  signGDPR: "/api/clients/GDPR/getPDF",
  profitEstimates: "/api/vehicule/estimatedCostsAndProfits",
  autovit: "/api/autovit",
  bestauto: "/api/bestauto",
  publi24: "/api/publi24",
  websitesIntegration: "/api/websitesIntegrations",
  getCountries: "/api/clients/countries",
  getCitiesByCounty: "/api/clients/cities",
  notificationsType: "/api/notifications/get/types",
  oauthEtransport: "/api/oauth",
  etransportRefreshToken: "/api/refreshToken",
  callbackEtransport: "/api/callback",
  uploadNotification: "/api/upload/notificare",
  deleteNotificare: "/api/delete/notificare",
  getEtransportNotifications: "/api/transports",
  getEtransportNotification: "/api/transport",
  getBunuriTransportate: "/api/bunuriTransportate",
  unitateMasura: "/api/unitateMasura",
  updateShipping: "/api/vehicule/shipping/updateShipping",
  soldVehiclesForUser: "/api/vehicule/soldForUser",
  userBonuses: "/api/userBonuses",
  removeShipping: "/api/shippings/remove",
  vehicleCost: "/api/vehicleCost",
  usersForSalaries: "/api/users/active/forSalaries",
  downloadFinancialSummary: "/api/salary/exportFinancialSumary",
  duplicateVehicle: "/api/vehicule/duplicate/vehicle/data/record",
  deactivateIntermediated: "/api/vehicule/deactivateIntermediated",
  activateIntermediated: "/api/vehicule/activateIntermediated",
  exportVehiclesTable: "/api/vehicule/export/table/data/as/excel",
  exportClientsTables: "/api/clients/export/table/data",
  anafNotifications: "/api/anaf/notifications",
  promoteAd: "/api/promote/ad",
  plusAuto: "/api/plusauto",
  xauto: "/api/xauto",
  xautoPublished: "/api/xauto/published",
  xautoDeactivate: "/api/xauto/deactivate",
  xautoActivate: "/api/xauto/activate",
  documents: "/api/all-documents",
  locationSettings: "/api/location-settings",
  scanVehiclePhoto: "/api/scan-car-photo",
  scanVehicleBrief: "/api/scan-vehicle-document",
  leadFollowUps: "/api/leadFollowUps",
  tasks: "/api/tasks",
  subtasks: "/api/subtasks",
} as const;

export type ApiEndpointKey = keyof typeof apiEndpoints;
